import type { QueryResult } from '@apollo/react-hooks';
import { useQuery, gql } from '@apollo/react-hooks';
import { getWorkOrderRelatedCounts } from '#/graphql/queries';
import type { GetWorkOrderRelatedCountsQuery } from '#/graphql/types';

const q = gql(getWorkOrderRelatedCounts);

const useWorkOrderRelatedCounts = (workOrderId: string) => {
  const { data, loading }: QueryResult<GetWorkOrderRelatedCountsQuery> = useQuery(q, {
    variables: { workOrderId },
  });

  return { ...(data?.getWorkOrderRelatedCounts ?? {}), loading };
};

export default useWorkOrderRelatedCounts;
